export default __webpack_public_path__ + "23f194617efa0c7e41674c7c18a58234.png";